import { Controller } from "@hotwired/stimulus"
import Quimbee from "quimbee"

export default class extends Controller {
  static targets = ["seats", "pricePerSeat", "ctaUrl"]
  static values = {
    tiers: Array,
    minimumSeats: Number
  }

  connect() {
    this.seatsTarget.value = this.minimumSeatsValue
    this.updatePriceAndCTA()
  }

  updatePriceAndCTA() {
    const seats = parseInt(this.seatsTarget.value || 0)
    let seatPrice = 0

    for (const tier of this.tiersValue) {
      if (seats <= tier.up_to || tier.up_to === "inf") {
        seatPrice = tier.unit_amount / 100
        break
      }
    }

    this.pricePerSeatTarget.textContent = `$${seatPrice}`

    if (seats && seats >= this.minimumSeatsValue) {
      this.updateCTA(seats)
      this.enableCTA()
    } else {
      this.disableCTA()
    }
  }

  enableCTA() {
    this.ctaUrlTarget.removeAttribute("disabled")
  }

  disableCTA() {
    this.ctaUrlTarget.setAttribute("disabled", true)

  }

  updateCTA(seats) {
    if (Quimbee.isSignedInUser) {
      this.updateCTAForSignedInUser(seats)
    } else {
      this.updateCTAForSignedOutUser(seats)
    }
  }

  // logged in user directly links to stripe checkout
  updateCTAForSignedInUser(seats) {
    const url = new URL(this.ctaUrlTarget.href)
    const searchParams = new URLSearchParams(url.search)
    searchParams.set('seats', seats)
    url.search = searchParams.toString()
    this.ctaUrlTarget.href = url.toString()
  }

  // logged out user has modal popup to register for a Quimbee account first
  updateCTAForSignedOutUser(seats) {
    const modalElement = document.getElementById('subscription_sign_up_continue_to')
    if (modalElement) {
      // update the modal element directly if it has been instantiated
      const currentUrl = modalElement.value
      const newUrl = currentUrl.split("seats=")[0] + "seats=" + seats
      modalElement.value = newUrl
    } else {
      // update the CTA button if modal has not been instantiated
      const continueTo = this.ctaUrlTarget.getAttribute('data-continue-to')
      const newUrl = continueTo.split("seats=")[0] + "seats=" + seats
      this.ctaUrlTarget.setAttribute('data-continue-to', newUrl)
    }
  }

  addSeat() {
    this.seatsTarget.value = parseInt(this.seatsTarget.value || 0) + 1
    this.updatePriceAndCTA()
  }

  removeSeat() {
    const units = parseInt(this.seatsTarget.value || 0)

    if (units > this.minimumSeatsValue) {
      this.seatsTarget.value = parseInt(this.seatsTarget.value) - 1
      this.updatePriceAndCTA()
    }
  }
}
